import type { ChargePresentation, ElementSelection } from '../../api/presentation.js';

export type OeuvrePresentation = ChargePresentation['elements'][number];
export const cleElementPresentation = (element: ElementSelection) =>
  `${element.oeuvreId}:${element.exemplaireId ?? ''}`;
export function prixElementPresentation(element: OeuvrePresentation): number | null {
  const prix = element.exemplaire?.prixCentimes ?? element.oeuvre.prixPublicCentimes;
  return typeof prix === 'number' ? prix : null;
}
